import React, { useEffect, useState } from 'react';
import { setAdminLTEBodyMode } from '../../hooks/useAdminLTEAssets';

const NAV_ITEMS = [
  { path: '/dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt', match: (p) => p === '/dashboard' },
  {
    path: '/conversations',
    label: 'Conversations',
    icon: 'fas fa-comments',
    match: (p) => p === '/conversations',
  },
  {
    path: '/dashboard/feedback',
    label: 'Feedback',
    icon: 'fas fa-star',
    match: (p) => p === '/dashboard/feedback',
  },
  {
    path: '/dashboard/admins',
    label: 'Manage admins',
    icon: 'fas fa-users-cog',
    match: (p) => p === '/dashboard/admins',
  },
  {
    path: '/dashboard/config',
    label: 'Config status',
    icon: 'fas fa-cog',
    match: (p) => p === '/dashboard/config',
  },
];

function isActive(pathname, item) {
  return item.match(pathname);
}

export default function AdminLTELayout({
  user,
  pathname,
  onRefresh,
  onSyncSheets,
  onSignOut,
  loading,
  syncingSheets,
  children,
}) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    setAdminLTEBodyMode({ login: false, collapsed: sidebarCollapsed });
    return () => setAdminLTEBodyMode({ login: false, collapsed: false });
  }, [sidebarCollapsed]);

  const displayName = user?.username || user?.email || 'Admin';

  return (
    <div className="wrapper">
      <nav className="main-header navbar navbar-expand navbar-white navbar-light border-bottom-0">
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              type="button"
              className="nav-link btn btn-link"
              onClick={() => setSidebarCollapsed((c) => !c)}
              aria-label="Toggle sidebar"
            >
              <i className="fas fa-bars" />
            </button>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <span className="nav-link text-muted">Berwind Avatar</span>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto align-items-center">
          <li className="nav-item d-none d-md-inline-block mr-2">
            <span className="text-muted small">
              <i className="fas fa-user mr-1" />
              {displayName}
            </span>
          </li>
          {onSyncSheets && (
            <li className="nav-item">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary mr-1"
                onClick={onSyncSheets}
                disabled={syncingSheets || loading}
                title="Download Google Sheet and upsert sessions into Supabase"
              >
                <i className={`fas fa-cloud-download-alt mr-1 ${syncingSheets ? 'fa-spin' : ''}`} />
                {syncingSheets ? 'Syncing…' : 'Sync from Sheet'}
              </button>
            </li>
          )}
          <li className="nav-item">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary mr-1"
              onClick={onRefresh}
              disabled={loading || syncingSheets}
            >
              <i className={`fas fa-sync-alt mr-1 ${loading ? 'fa-spin' : ''}`} />
              Refresh
            </button>
          </li>
          <li className="nav-item">
            <button type="button" className="btn btn-sm btn-default" onClick={onSignOut}>
              <i className="fas fa-sign-out-alt mr-1" />
              Sign out
            </button>
          </li>
        </ul>
      </nav>

      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <a href="/dashboard" className="brand-link text-center">
          <span className="brand-text font-weight-light ml-0">Berwind Dashboard</span>
        </a>
        <div className="sidebar">
          <div className="user-panel mt-3 pb-3 mb-3 d-flex border-bottom-0">
            <div className="image">
              <span className="img-circle elevation-2 bg-primary d-inline-flex align-items-center justify-content-center text-white">
                <i className="fas fa-user" />
              </span>
            </div>
            <div className="info">
              <span className="d-block text-truncate" style={{ maxWidth: 160 }}>
                {displayName}
              </span>
            </div>
          </div>
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
              {NAV_ITEMS.map((item) => (
                <li className="nav-item" key={item.path}>
                  <a
                    href={item.path}
                    className={`nav-link ${isActive(pathname, item) ? 'active' : ''}`}
                  >
                    <i className={`nav-icon ${item.icon}`} />
                    <p>{item.label}</p>
                  </a>
                </li>
              ))}
              <li className="nav-header">LINKS</li>
              <li className="nav-item">
                <a href="/" className="nav-link">
                  <i className="nav-icon fas fa-robot" />
                  <p>Avatar app</p>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </aside>

      <div className="content-wrapper">
        <section className="content pt-3">
          <div className="container-fluid">{children}</div>
        </section>
      </div>

      <footer className="main-footer text-sm">
        <strong>Berwind Avatar</strong> conversation dashboard.
        <div className="float-right d-none d-sm-inline-block">
          <a href="https://adminlte.io/themes/v3/" target="_blank" rel="noopener noreferrer">
            AdminLTE 3
          </a>
        </div>
      </footer>
    </div>
  );
}
